{
  "slug": "low-iq-scores-explained",
  "title": "تفسير الدرجات المنخفضة لمعدل الذكاء بشكل مسؤول",
  "description": "فهم نطاقات أدنى من علامات الذكاء، وفترات الثقة، والوظيفة التكيفية، ولماذا لا يحدد العلامة وحدها شخصا أو يحدد تشخيصا.",
  "summary": "إن نتيجة معدل الذكاء المنخفض تصف الأداء في مهام مختارة مقارنة بمجموعة معيارية. وهي تتطلب تفسيراً دقيقاً واحترامياً إلى جانب عدم اليقين، واحتياجات الوصول، والتنمية، والوظائف اليومية.",
  "category": "تفسير معدل الذكاء",
  "sections": [
    {
      "heading": "ماذا يمكن أن يعنيه التصنيف الأدنى وما لا يمكن أن يعنيه",
      "paragraphs": [
        "على مدى100, SD- )الجزء اﻷول(15 الدرجات الممنوحة أدناه 85 أقل من متوسط السكان ومستويات تقترب من 100 في المائة 70 ويعتمد المئيني الدقيق والتصنيف على الأداة والمعايير المستخدمة في تحديد القيمة المئوية.",
        "إن النتيجة لا تقيس القيمة الإنسانية، أو اللطف، أو الإبداع، أو الخبرة العملية، أو كل قدرة. فاللغة، والتعليم، والقدرة الحسية أو الحركية، والصحة، والاهتمام، وظروف الاختبار قد تؤثر على الأداء."
      ]
    },
    {
      "heading": "لا يتم التشخيص من معدل الذكاء وحده",
      "paragraphs": [
        "إن التقييم المهني للإعاقة الذهنية ينظر إلى الأداء الذهني إلى جانب الأداء التكيفي في المجالات المفاهيمية والاجتماعية والعملية للحياة، مع بدء ذلك خلال فترة النمو. ولا يمكن لدرجة واحدة على الإنترنت أو الفحص أن تحدد هذا التشخيص.",
        "ويقوم المقيّم المؤهل باختيار التدابير المناسبة، والنظر في أوجه التكيف والخلفية، وفحص نطاق الثقة، ودمج المعلومات المستمدة من أكثر من مصدر واحد."
      ]
    },
    {
      "heading": "استخدام النتائج لفهم احتياجات الدعم",
      "paragraphs": [
        "والسؤال البناء هو أي المهام أسهل أو أصعب، وما هو الدعم الذي يحسن المشاركة. إن التعليمات الواضحة، والوقت الإضافي عند الاقتضاء، والتكنولوجيا المساعدة، والتعليم، والتغييرات البيئية، كل هذا قد يشكل أهمية.",
        "وإذا كانت النتيجة المنخفضة غير متوقعة أو قد تؤثر على الخدمات، فاناقشها مع مهني مؤهل بدلا من القيام باختبارات متكررة على الإنترنت أو معاملة نقطة النهاية على أنها دقيقة تماما."
      ]
    }
  ],
  "faqs": [
    {
      "question": "معدل الذكاء أقل من 18 70 يعني تلقائياً إعاقة ذهنية؟",
      "answer": "لا. يتطلب التشخيص أيضاً تقييم الأداء التكيفي وتاريخ النمو، باستخدام المعايير المهنية المناسبة."
    },
    {
      "question": "هل يمكن أن تؤدي ظروف الاختبار إلى خفض الدرجات؟",
      "answer": "نعم، يمكن أن يؤثر الإجهاد والمرض والقلق وعدم توافق اللغة وعدم التركيز والحواجز التي تعترض الوصول وغير ذلك من الظروف على الأداء."
    }
  ],
  "related": ["iq-80-meaning", "iq-score-ranges-explained", "how-is-iq-measured"],
  "sources": [
    {
      "label": "رابطة المعوقين عقليا - أسئلة وأجوبة عن الإعاقة الذهنية",
      "url": "https://www.aaidd.org/docs/default-source/intellectualdisability/12th-ed-twenty-questions-faq.pdf"
    },
    {
      "label": "بيرسون - وايس -5 تقرير تقييم العينة",
      "url": "https://www.pearsonassessments.com/content/dam/school/global/clinical/us/assets/wais-5/wais-5-sample-score-report.pdf"
    }
  ]
}
